import React, { useEffect, useState } from 'react';
import axios from 'axios';
import OpenInNewRoundedIcon from '@material-ui/icons/OpenInNewRounded';
import PhotoLibraryOutlinedIcon from '@material-ui/icons/PhotoLibraryOutlined';
import { SectionButton } from '../../components/DetailSection/DetailSection';
import { apiList, verifyLogin } from '../../helpers';
import { ACTIVITY_BY_KEY, COL, idleText } from './mapMeta';

// The selected loan, shown in the pop-up on its pin.

const money = (n) => (n || n === 0 ? `₹${Math.round(n).toLocaleString('en-IN')}` : '—');

export default function LoanCard({
  row, onOpenLoan, onPhotos, onLayout,
}) {
  const loanId = row[COL.loanId];
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setData(null);
    setError('');
    const { session } = verifyLogin();
    axios.get(`${apiList.MAP_LOANS}/${loanId}`, {
      headers: { session, permissionConfig: 'Property Details', feature: 'view' },
    })
      .then((r) => { if (active) setData(r.data.data); })
      .catch(() => { if (active) setError('Could not load this loan.'); });
    return () => { active = false; };
  }, [loanId]);

  // Let the pop-up resize to the loaded content.
  useEffect(() => { if (onLayout) onLayout(); }, [data, error]);

  const activity = ACTIVITY_BY_KEY[(data && data.activity) || row[COL.activity]];
  const plan = data?.plan;

  return (
    <div className='lm-pop'>
      <div className='lm-pop-title'>{row[COL.loanNumber] || 'N/A'}</div>
      <div className='lm-pop-sub'>
        {[row[COL.custName], data?.branchName].filter(Boolean).join(' · ')}
      </div>
      <div className='lm-status'>
        <span
          className='lm-dot'
          style={{ background: activity.color, boxShadow: activity.stroke ? `0 0 0 1px ${activity.stroke}` : undefined }}
        />
        {`${activity.label} · ${idleText(data ? data.idleDays : row[COL.idleDays])}`}
      </div>

      {error ? <div className='lm-alert'>{error}</div> : null}
      {!data && !error ? <div className='lm-pop-loading'>Loading…</div> : null}

      {data ? (
        <>
          {data.offsitePhotos ? (
            <div className='lm-alert'>
              {`${data.offsitePhotos} photo${data.offsitePhotos === 1 ? '' : 's'} taken outside the allowed radius (last ${data.offsiteDays} days)`}
            </div>
          ) : null}
          <div className='lm-pop-progress'>
            <span>Progress (verified)</span>
            <strong>{plan.progress === null ? 'No plan' : `${plan.progress}%`}</strong>
          </div>
          {plan.progress !== null ? (
            <div className='lm-progress'><span style={{ width: `${Math.min(100, plan.progress)}%` }} /></div>
          ) : null}
          <dl className='lm-facts'>
            <div>
              <dt>Verified</dt>
              <dd>{plan.activities ? `${plan.verified} of ${plan.activities}` : '—'}</dd>
            </div>
            <div>
              <dt>Awaiting review</dt>
              <dd>{plan.submitted + plan.uploading ? `${plan.submitted + plan.uploading}` : 'None'}</dd>
            </div>
            <div>
              <dt>Open requests</dt>
              <dd>{data.openRequests ? `${data.openRequests} · ${data.latestOpenRequest || ''}` : 'None'}</dd>
            </div>
            <div>
              <dt>Last upload</dt>
              <dd>{data.lastUpload || '—'}</dd>
            </div>
            <div className='wide'>
              <dt>Disbursed / sanctioned</dt>
              <dd>{`${money(data.disbursedAmount)} of ${money(data.sanctionedAmount)}`}</dd>
            </div>
            {!data.geoTagging ? (
              <div className='wide'>
                <dt>Geo-tagging</dt>
                <dd>Off for this loan</dd>
              </div>
            ) : null}
          </dl>
        </>
      ) : null}

      <div className='lm-actions'>
        <SectionButton icon={OpenInNewRoundedIcon} onClick={() => onOpenLoan(loanId)}>
          Open loan
        </SectionButton>
        <SectionButton icon={PhotoLibraryOutlinedIcon} onClick={() => onPhotos(row)}>
          Photo locations
        </SectionButton>
      </div>
    </div>
  );
}
